var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Nuxt'),_vm._v(" "),_c('Lfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }